'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ErrorState = require('../../message-preview/components/ErrorState');

var _ErrorState2 = _interopRequireDefault(_ErrorState);

var _loadI18n = require('../../utils/loadI18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AsyncMessagesPreview = function (_React$Component) {
  _inherits(AsyncMessagesPreview, _React$Component);

  function AsyncMessagesPreview(props) {
    _classCallCheck(this, AsyncMessagesPreview);

    var _this = _possibleConstructorReturn(this, (AsyncMessagesPreview.__proto__ || Object.getPrototypeOf(AsyncMessagesPreview)).call(this, props));

    _this.state = {
      AsyncComponent: null,
      error: null
    };
    return _this;
  }

  _createClass(AsyncMessagesPreview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _q2.default.Promise.all([import( /* webpackChunkName: "messages-preview" */'../../message-preview/containers/MessagePreviewContainer'), (0, _loadI18n.loadI18n)()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            AsyncModule = _ref2[0];

        _this2.setState({
          AsyncComponent: AsyncModule.default
        });
      }, function (error) {
        _this2.setState({
          error: error
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var Component = this.state.AsyncComponent;

      if (this.state.error) {
        return _react2.default.createElement(_ErrorState2.default, null);
      }

      if (!Component) {
        return null;
      }

      return _react2.default.createElement(Component, this.props);
    }
  }]);

  return AsyncMessagesPreview;
}(_react2.default.Component);

AsyncMessagesPreview.displayName = 'AsyncMessagesPreview';

exports.default = AsyncMessagesPreview;
module.exports = exports['default'];